var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"btTabs"},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:tab.label,staticClass:"button is-light spaced-button",attrs:{"to":tab.link}},[_c('span',[_vm._v(_vm._s(tab.label))])])}),1),_vm._v(" "),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }